import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import TransitionsModal from "./Modal";
import { Backdrop, Fade, Modal } from "@mui/material";
import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";


const images = [
  {
    label: "The worker of the month",
    imgPath:
      "https://cxuniversity.com/wp-content/uploads/2018/09/3736-min.jpg",
    modalDescription:
      "A tilte that given to the exceptional worker in the volunteering aspect, doing.  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel."
    
  },
  {
    label: "Work Together",
    imgPath:
      "https://img.huffingtonpost.com/asset/5cd6fd50240000310076eccd.jpeg?ops=1778_1000",
    modalDescription:
      "Four workers, Three days, Two goals, and One school who got a whole new dynamic learning room. The story from a 8 y.o student. Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel."
    
  },
  {
    label: "Great Deal",
    imgPath:
      "https://www.jme-hr.com/wp-content/uploads/2017/10/shutterstock_653243296-1800x1200.jpg",
    modalDescription:
        "We did it! Two and half years of talking and planning finally comming around to one last hand shake between our CEO and Microsoft's CEO.  Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel."
      
  },
  {
    label: "Success is the key!",
    imgPath: "https://thumbs.dreamstime.com/b/successful-company-happy-workers-modern-office-160437985.jpg",
    modalDescription:
              "A long time ago our company was intervene in a scholarship for low economic status, we proud to see the seeds that we sowed bear fruit Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit. Molestias omnis deleniti deserunt, aliquam voluptatum reiciendis dolor. Eaque quas atque a cumque vel, doloremque ea voluptas eum quasi officia eveniet esse! Lorem ipsum dolor sit amet consectetur, adipisicing elit.."
            
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "70%",
  height: "fit contant",
  color: "black",
  bgcolor: "#ffe6a7",
  border: "2px solid #ffe6a7",
  borderShadow: 24,
  p: 4,
  borderRadius: 10,
};


function SwipeableTextMobileStepper() {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const maxSteps = images.length;
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ maxWidth: 400, flexGrow: 1 }} data-aos="flip-up">
      <Paper
        square
        elevation={0}
        sx={{
          display: "flex",
          alignItems: "center",
          height: 50,
          pl: 2,
          bgcolor: "background.default",
        }}
      >
        <Typography>{images[activeStep].label}</Typography>
      </Paper>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <>
                <Box
                onClick={handleOpen}
                component="img"
                sx={{
                  height: 255,
                  display: 'block',
                  maxWidth: 400,
                  overflow: 'hidden',
                  width: '100%',
                }}
                src={step.imgPath}
                alt={step.label}
              />
              <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open}
              onClose={handleClose}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open}>
                <Box sx={style}>
                  <Typography id="transition-modal-title" variant="h6" component="h2">
                    {images[activeStep].label}
                  </Typography>
                  <Typography id="transition-modal-description" sx={{ mt: 2 }}>
                    {images[activeStep].modalDescription}
                  </Typography>
                </Box>
              </Fade>
            </Modal>
          </>
          ) : null}
          </div>
        ))}
      </SwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === "rtl" ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === "rtl" ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  );
}

export default SwipeableTextMobileStepper;
